









import Vue from 'vue';
import Store from '@/services/Store';
import MainArea from '@/components/MainArea.vue';
import ImageArea from '@/components/ImageArea.vue';
import TextArea from '@/components/TextArea.vue';
import { Piano, fId } from '@/services/Utility';

export default Vue.extend({
	name: 'QuizIntro',
	data() {
		return {
			quizImage: Store.quizState.getQuizImage(),
			introText: Store.quizState.getRandomIntro().text,
		};
	},
	mounted() {
		let t = Store.quizState.getQuizTitle().match(/(\w+)/g);
		let title = t !== null ? `__${t[0]}${typeof t[1] !== 'undefined' ? `_${t[1]}` : ''}` : '';
		Piano ({t: 'page.display', p: {inhaltstyp: title, seitenname_id: 'indexSeite', seitentitel: Store.quizState.getQuizTitle() }});
		// ATI({ x6: title, x7: 'indexPage', x8: Store.quizState.getQuizTitle() });
		// console.log(`fId: ${fId}, height: ${document.getElementById('app').clientHeight}`);
		window.setTimeout(() => {
			// because mounted() ist called too early ...
			let prms = { status: 200, h: this.$root.$el.clientHeight, tgt: fId };
			// console.log(`QuizIntro: will post ${JSON.stringify(prms)}`);
			if (window.self !== window.top) {
				parent.postMessage(prms, 'https://www.br.de');
			}
		}, 500);
	},
	activated() {
		console.log(`activated: ${this.$root.$el.clientHeight}px height.`);
	},
	methods: {
		handleStartBtnClick() {
			console.log(`cat-Parameter: ${this.$route.query.cat}`);
			Piano({t:'click.navigation', p:{click:'btnStart', click_chapter1:'navigationButton'}})

			this.$router.push({ name: 'QuizQuestion', params: { quiz: 'play' } });
		},
	},
	components: {
		MainArea,
		ImageArea,
		TextArea,
	},
});
